import React from 'react'
import { FormattedMessage } from 'react-intl'

export default ({ data, onLotProceed }) => (
  <div>
    <h1 className='Signin__title Head'><FormattedMessage id='bid.agreement_title' /></h1>
    {/* <div style={{ marginBottom: 40 }} dangerouslySetInnerHTML={{ __html: data }} /> */}
    <div className='Payments__text_sm' style={{ marginBottom: 40 }}> Для подтверждения карты выполняются дополнительные действия, позволяющие проверить, что карта является действующей, и ее владельцем являетесь вы.<br></br>

 

Для подтверждения карты с ее счета будет списана сумма в размере <b>10 000 руб</b>.  После подтверждения карты возмещение указанной суммы будет зачислено на вашу карту. Возмещение занимает <b>до 30 дней</b>, в зависимости от компании-эмитента карты.</div>
    <button type='submit' className='Main__founds-button Button Button_white' onClick={onLotProceed}><FormattedMessage id='bid.proceed' /></button>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/Lot/LotBidAgree.jsx